<template>
  <div style="width: 100%;margin: auto">
    <el-table :data="dataList" :show-header="false" highlight-current-row border v-loading="loading">
      <el-table-column label="#" align="center" width="80">
        <template slot-scope="{row}">
          <el-button type="text" v-if="row.id===currentUserId" disabled>
            当前登录
          </el-button>
          <el-button type="text" icon="el-icon-s-unfold" @click="switchAccount(row)" v-else
                     :disabled="row.id===currentUserId">
            切换
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="avatar" label="头像" min-width="80" align="center">
        <template slot-scope="{row}">
          <el-avatar :size="size" :src="row.avatar"></el-avatar>
        </template>
      </el-table-column>
      <el-table-column prop="username" label="账号" min-width="230" align="center" show-overflow-tooltip>
        <template slot-scope="{row}">
          {{ row.username || '' }}/{{ row.name || '' }}/{{ row.login_at ? $utils.parseTime(row.login_at) : '' }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {getMyAccounts, getPermissions, switchAccount} from "@/api/auth";
import {getAuth} from "@/api/login";
import store from "@/store";

export default {
  name: "MyAccounts",
  computed: {
    currentUserId() {
      let currentUser = this.$store.getters.getUser;
      return currentUser ? currentUser.id : 0;
    },
  },
  data() {
    return {
      loading: false,
      dataList: []
      , size: 'large'//["large", "medium", "small"]
    }
  },
  methods: {
    getMyAccountList() {
      this.loading = true
      getMyAccounts().then((res) => {
        this.dataList = res.model || []
        this.loading = false
      })
    },
    switchAccount(row) {
      this.$msgbox.confirm(`即将切换到账号【${row.username}】，请确保的表单等数据已保存，切换账号后，将刷新页面, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        //请求切换到指定账号
        let tokenData = await switchAccount(row.id).then((res) => {
          //逻辑同登录成功
          return res.model;
        })
        this.$utils.lsSet('token', tokenData.access_token, tokenData.expires_in * 1000)
        //校验通过后，刷新用户的权限等信息
        // await getPermissions();
        await this.loginSuccess(tokenData)

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    // 登录成功后
    async loginSuccess() {
      // 加载权限
      let permissions = await getPermissions().then((res) => {
        return res.model;
      })
      await store.commit('handleUserPermissions', permissions)

      //加载用户信息：登录成功后， 获取用户信息
      let userInfo = await getAuth().then(res => {
        return res.model;
      })

      await this.$store.dispatch('login', userInfo);
      //页面跳转到首页
      await this.$router.push({path: '/'});
    }
  },
  mounted() {
    let token = this.$utils.lsGet('token')
    if (token)
      this.getMyAccountList()
  }
}
</script>

<style>


</style>
